import React from 'react';
import {Route, Switch, useHistory} from 'react-router-dom';

import {IEntityMeta} from 'entities/metadata';
import {IFormEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';

import {EFormMode} from '../../form';
import {FormEditModal} from '../../form-edit-modal/form-edit-modal';
import {Form} from '../../form/form';

import './directory-form-item.less';

export interface IDirectoryFormItemProps {
    url: string;
    data: Record<string, unknown>;
    metadata: IEntityMeta;
    referenceUrl: string;
}

export const DirectoryFormItem = ({
    url, referenceUrl, data, metadata,
}: IDirectoryFormItemProps) => {
    const history = useHistory();

    const handleClose = () => {
        history.go(-1);
    };

    return (
        <Switch>
            <div className="directory-item">
                <Route
                    path={url}
                    render={() => (
                        <Form
                            onClose={() => {
                            }}
                            actionForForm={() => {
                            }}
                            formStyle={{width: metadata?.width}}
                            meta={{...metadata, actions: []}}
                            formData={{data} as IFormEntityData}
                            // as form here is used to render only fields, I suppose it will be always disabled
                            mode={EFormMode.REPRESENTATION}
                        />
                    )}
                />
                <Route
                    path={`${url}/:id`}
                    render={() => (
                        <FormEditModal
                            entityName={metadata.name}
                            onClose={handleClose}
                            referenceUrl={referenceUrl}
                            resetEntityName={metadata.name}
                            resetEntityType={EEntityType.TABS_WITH_FORM}
                        />
                    )}
                />
            </div>
        </Switch>
    );
};
